import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatColors } from '../../../../../core/matColors';
import { TicketModel } from '../ticket.model';

@Component({
    selector: 'fuse-ticket-form-dialog',
    templateUrl: './ticket-form.component.html',
    styleUrls: ['./ticket-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TicketFormDialogComponent implements OnInit {
    ticket: TicketModel;
    dialogTitle: string;
    eventForm: FormGroup;
    action: string;
    presetColors = MatColors.presets;

    constructor(
        public dialogRef: MatDialogRef<TicketFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private formBuilder: FormBuilder
    ) {
        this.ticket = data.ticket;
        this.action = data.action;

        if (this.action === 'edit') {
            this.dialogTitle = this.ticket.title;
        }
        else {
            this.dialogTitle = 'Nouveau tarif';
            this.ticket = new TicketModel();
        }

        this.eventForm = this.createEventForm();
    }

    ngOnInit() {
    }

    createEventForm() {
        return new FormGroup({
            _id: new FormControl(this.ticket._id),
            title: new FormControl(this.ticket.title, [Validators.required]),
            description: new FormControl(this.ticket.description),
            title_en: new FormControl(this.ticket.title_en, [Validators.required]),
            description_en: new FormControl(this.ticket.description_en),
            amount: new FormControl({ value: this.ticket.amountVat10 + this.ticket.amountVat20, disabled: true }),
            amountVat10: new FormControl(this.ticket.amountVat10, [Validators.required, Validators.min(0)]),
            amountVat20: new FormControl(this.ticket.amountVat20, [Validators.required, Validators.min(0)]),
            vat10:new FormControl(this.ticket.amountVat10, [Validators.required, Validators.min(0)]),
            vat20:new FormControl(this.ticket.amountVat20, [Validators.required, Validators.min(0)]),
            discountAmount: new FormControl(this.ticket.discountAmount, [Validators.required, Validators.min(0)]),
            vatRate: new FormControl(this.ticket.vatRate, [Validators.required, Validators.min(0)]),
            hidden: new FormControl(this.ticket.hidden),
            unlimited: new FormControl(this.ticket.unlimited),
            // allDay: new FormControl(this.event.allDay),
            // color : this.formBuilder.group({
            //     primary  : new FormControl(this.event.color.primary),
            //     secondary: new FormControl(this.event.color.secondary)
            // }),
            // meta  :
            //     this.formBuilder.group({
            //         location: new FormControl(this.event.meta.location),
            //         notes   : new FormControl(this.event.meta.notes)
            //     })
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/product/ticket-form/ticket-form.component.ts